<template>
  <v-form ref="mainForm" v-model="valid">
    <CatalogueLive
      code="publi_ouinon"
      v-model="sas.sasEquivalence.desireAjouterPublications"
      :live="{ endpoint: 'sas-equivalence', cle: '6146', fileId: sas.sasEquivalence.id }"
    />
    <data-iterator
      :list="sas.sasPublications"
      add-new-text="Ajouter une publication"
      :live="{ endpoint: 'sas-publication', sasId: sas.id }"
      :icon="$getIcon('publication')"
      :valids="valids"
      ref="dataIterator"
      :opqIf="estOui(sas.sasEquivalence.desireAjouterPublications)"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.titre }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="publi_titre" v-model="item.titre" :live="liveSasPublication(8602, item)" />
        <MemoLive code="publi_description" v-model="item.descriptionSpecifique" :live="liveSasPublication(8603, item)" />
        <FileInput code="publi_fichier" :file="item.fichier" :live="liveSasPublication(8604, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasPublication(cle, item) {
      return { endpoint: "sas-publication", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>